import React from "react";
import { useHistory } from "react-router-dom";
import EasyButton from "../../../../_components/Button/EasyButton";
import { useShowMe } from "./hooks";

export default (props) => {
  const history = useHistory();
  const [show, setShow] = React.useState(false);
  const handleShowMe = useShowMe();

  function onClick() {
    history.push("/news");
  }

  React.useEffect(() => {
    setShow(handleShowMe());
  }, [location.pathname]);

  if (show) {
    return (
      <EasyButton
        onClick={onClick}
        iconPosition="right"
        type="success"
        label="Ei, temos novidades"
        icon="fas fa-bullhorn"
        size=".9em"
      />
    );
  } else {
    return <span />;
  }
};



// WEBPACK FOOTER //
// ./src/views/AppViews/TopHeader/ButtonNews/index.jsx